export const available_attributes = {
  archive: [
    "custom_key",
    "start_date",
    "alternative",
    "basis_of_record",
    "bibliographic_citation",
    "conforms_to",
    "contributor",
    "coverage",
    "create_date",
    "created",
    "creator",
    "date",
    "description",
    "display_date",
    "extent",
    "format",
    "format_physical",
    "has_format",
    "has_part",
    "has_version",
    "identifier",
    "is_format_of",
    "is_part_of",
    "is_version_of",
    "language",
    "license",
    "medium",
    "other_identifier",
    "provenance",
    "publisher",
    "references",
    "relation",
    "repository",
    "rights_holder",
    "rights",
    "source",
    "spatial",
    "subject",
    "tags",
    "temporal",
    "type"
  ],
  collection: [
    "size",
    "bibliographic_citation",
    "create_date",
    "creator",
    "description",
    "display_date",
    "identifier",
    "is_part_of",
    "language",
    "provenance",
    "relation",
    "rights_holder",
    "rights",
    "source",
    "spatial",
    "subject"
  ]
};

export const archive_multiFields = [
  "alternative",
  "basis_of_record",
  "bibliographic_citation",
  "conforms_to",
  "contributor",
  "coverage",
  "created",
  "creator",
  "date",
  "description",
  "display_date",
  "extent",
  "format",
  "format_physical",
  "has_format",
  "has_part",
  "has_version",
  "is_format_of",
  "is_part_of",
  "is_version_of",
  "language",
  "license",
  "medium",
  "other_identifier",
  "provenance",
  "publisher",
  "references",
  "relation",
  "repository",
  "rights_holder",
  "rights",
  "source",
  "spatial",
  "subject",
  "tags",
  "temporal",
  "type"
];

export const archive_singleFields = [
  "end_date",
  "identifier",
  "manifest_url",
  "start_date",
  "title",
  "thumbnail_path"
];

export const collection_multiFields = [
  "bibliographic_citation",
  "creator",
  "description",
  "display_date",
  "is_part_of",
  "language",
  "provenance",
  "relation",
  "rights_holder",
  "rights",
  "source",
  "spatial",
  "subject"
];

export const collection_singleFields = [
  "end_date",
  "identifier",
  "ownerinfo_email",
  "ownerinfo_name",
  "start_date",
  "title",
  "thumbnail_path"
];

export const csv_metadataFields = {
  archive: [
    "item_category",
    "parent_collection",
    "create_date",
    "modified_date",
    "thumbnail_path",
    "custom_key",
    "alternative",
    "basis_of_record",
    "bibliographic_citation",
    "conforms_to",
    "contributor",
    "coverage",
    "created",
    "creator",
    "date",
    "description",
    "display_date",
    "end_date",
    "explicit",
    "extent",
    "format",
    "has_format",
    "has_part",
    "has_version",
    "identifier",
    "is_format_of",
    "is_part_of",
    "is_version_of",
    "language",
    "license",
    "medium",
    "other_identifier",
    "provenance",
    "publisher",
    "references",
    "relation",
    "repository",
    "rights_holder",
    "rights",
    "source",
    "spatial",
    "start_date",
    "subject",
    "tags",
    "temporal",
    "type",
    "visibility"
  ],
  collection: [
    "collection_category",
    "parent_collection",
    "create_date",
    "modified_date",
    "thumbnail_path",
    "custom_key",
    "ownerinfo",
    "bibliographic_citation",
    "creator",
    "description",
    "display_date",
    "end_date",
    "explicit_content",
    "identifier",
    "is_part_of",
    "language",
    "provenance",
    "relation",
    "rights_holder",
    "rights",
    "source",
    "spatial",
    "start_date",
    "subject",
    "title",
    "visibility"
  ]
};
